import styled from 'styled-components';
import { Radio } from 'ui/radio';

import { colors, spacing } from 'ui/theme';
import { body1, body2, body2Bold } from 'ui/theme/typography';

export const Spacer = styled.div`
  height: ${spacing.plusHalf};
  width: 100%;
  display: block;
`;

export const BaseContainer = styled.div`
  display: flex;
  align-items: center;
  [data-test='basic-select-project-select'] {
    width: 100%;
  }
  [data-test='basic-select-messageType-select'] {
    width: 100%;
  }
  [data-test='basic-select-sender-select'] {
    width: 100%;
  }
  [role='listbox'] {
    width: 100%;
  }
`;

export const PreviewContainer = styled(BaseContainer)`
  padding: ${spacing.threeQuarter};

  border: ${spacing.single} solid ${colors.grey15};
  box-sizing: border-box;
  border-radius: ${spacing.threeEights};
`;

export const RadioContainer = styled(BaseContainer)`
  padding: ${spacing.threeQuarter} 0 0 ${spacing.quarter};
  gap: ${spacing.x3};
`;

export const RadioOption = styled(BaseContainer)`
  margin-bottom: 0;
`;

export const Name = styled.span`
  ${body1}
  color: ${colors.textPrimary};
`;

// this is super gross, but this should probably be refactored to a label as it gets used with
// a radio form button. Using the `as` property brings in unwanted margin. Shouldn't conflict
// with anything because regular usage as span won't even accept margin.
export const Body2Span = styled.span`
  ${body2}
  margin: 0;
`;
export const Body2Label = styled.label`
  ${body2Bold}
`;

export const StyledRadio = styled(Radio)`
  margin-right: ${spacing.threeQuarter};
`;
